import React from 'react';
import styles from './login-content.module.scss';
import {Form, FormControl, FormLabel, Row} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {Link} from "react-router-dom";
import FormCheckInput from "react-bootstrap/FormCheckInput";
import FormCheckLabel from "react-bootstrap/FormCheckLabel";
import {useDispatch} from "react-redux";
import {login} from "@/actions/auth";
import {loading} from "@/actions/loader";


const LoginContent: React.FC<any> = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const dispatch = useDispatch();

    const onSubmit = (data: any) => {
        // todo google recaptcha
        loading()(dispatch);
        login(data.phone_number, data.password, data.remember)(dispatch).catch(console.log);
    };

    return (
        <div className={styles.login}>
            <Row>
                <div className="col-lg-6 d-none d-lg-block">
                    <img src="/images/samples/phone-music.png" alt="ورود به تکست نویس" />
                </div>
                <div className="col-lg-6 col-md-8 m-auto">
                    <div className={styles.form}>
                        <div className={styles.title}>
                            <div className={styles.optionsContainer + ' ' + styles.option1}>
                                <Link to={'/login'}>ورود</Link>
                                <Link to={'/register'}>ثبت نام</Link>
                            </div>
                        </div>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3">
                                <FormLabel htmlFor="phone_number">
                                    <i className="fa fa-phone" /> شماره تماس *
                                </FormLabel>
                                <FormControl className="ltr" id="phone_number" {...register('phone_number', {
                                    required: {
                                        message: "ورود شماره تماس الزامیست!",
                                        value: true
                                    }
                                })} />
                                {errors.phone_number && <p className="text-danger">{errors.phone_number.message as string}</p>}
                            </div>
                            <div className="mb-3">
                                <FormLabel htmlFor="password">
                                    <i className="fa fa-key-skeleton" /> رمز عبور *
                                </FormLabel>
                                <FormControl className="ltr" id="password" type="password" {...register('password', {
                                    required: {
                                        message: "ورود رمز عبور الزامیست!",
                                        value: true
                                    }
                                })} />
                                {errors.password && <p className="text-danger">{errors.password.message as string}</p>}
                            </div>
                            <div className={styles.rememberMe}>
                                <FormCheckInput id="remember" {...register('remember')} /> <FormCheckLabel htmlFor="remember">مرا به خاطر بسپار</FormCheckLabel>
                            </div>
                            <div className={'mt-4'}>
                                <input type="submit" value="ورود به تکست نویس" className="btn btn-primary" />
                                <a className="btn btn-danger float-start" href="/password/reset">
                                    <span className="d-sm-none d-block">
                                    فراموشی رمز
                                    </span>
                                    <span className="d-sm-block d-none">
                                    رمز عبور خود را فراموش کرده ام!
                                    </span>
                                </a>
                            </div>
                        </Form>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default LoginContent;
